var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 0C0.976 0 0.140437 0.772625 0.0234375 1.76562L10 8L19.9766 1.76562C19.8596 0.772625 19.024 0 18 0H2ZM0 3.75195V13C0 14.105 0.895 15 2 15H18C19.105 15 20 14.105 20 13V3.75195L10.5293 9.66992C10.2053 9.87192 9.7947 9.87192 9.4707 9.66992L0 3.75195Z",
    fill: "#00E9E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.7bd33bc49afe0f339b80055299655440.svg";
export { ForwardRef as ReactComponent };